// const url = "https://fnb-test.api.docsun.health/api/";
const url = "https://fnb.api.docsun.health/api/";

export default url;
